module.exports = __webpack_public_path__ + "static/media/head.bc7a9694.png";